import {
    FEED_APPLY_FILTER_CRITERIA,
    FEED_APPLY_MODEL_UPDATE,
    FEED_CANCEL_MODEL_UPDATE,
    FEED_CLEAR_FILTER_CRITERIA,
    FEED_KNOWLEDGE_ITEM_REQUEST,
    FEED_KNOWLEDGE_ITEM_RESPONSE,
    FEED_KNOWLEDGE_ITEM_FULLTEXT_RESPONSE,
    FEED_KNOWLEDGE_LIST_PAGE_REQUEST,
    FEED_KNOWLEDGE_LIST_RESPONSE,
    FEED_MODERATE,
    FEED_SET_EDIT_MODE,
    FEED_SET_KNOWLEDGE_FILTER,
    FEED_TOGGLE_REJECTION_REASON_MODAL,
    FEED_UPDATE_FILTER_CRITERIA,
    FEED_UPDATE_IMAGE,
    FEED_UPDATE_MODEL
} from "./action-types"
import {
    itemRequest,
    itemResponse,
    listPageRequest,
    listResponse,
    setFilter,
    setEditMode,
    updateFilterCriteria,
    clearFilterCriteria,
    applyFilterCriteria,
    updateImage,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate
} from "./default-actions/presentation-actions"

export const feedKnowledgeItemRequest = itemRequest(FEED_KNOWLEDGE_ITEM_REQUEST)
export const feedKnowledgeItemResponse = itemResponse(
    FEED_KNOWLEDGE_ITEM_RESPONSE
)
export const feedKnowledgeItemFulltextResponse = itemResponse(
    FEED_KNOWLEDGE_ITEM_FULLTEXT_RESPONSE
)
const feedKnowledgeListResponse = listResponse(FEED_KNOWLEDGE_LIST_RESPONSE)
export const feedKnowledgeListPageRequest = listPageRequest(
    FEED_KNOWLEDGE_LIST_PAGE_REQUEST,
    feedKnowledgeListResponse
)
export const feedSetKnowledgeFilter = setFilter(FEED_SET_KNOWLEDGE_FILTER)
export const feedSetEditMode = setEditMode(FEED_SET_EDIT_MODE)
export const feedUpdateFilterCriteria = updateFilterCriteria(
    FEED_UPDATE_FILTER_CRITERIA
)
export const feedClearFilterCriteria = clearFilterCriteria(
    FEED_CLEAR_FILTER_CRITERIA
)
export const feedApplyFilterCriteria = applyFilterCriteria(
    FEED_APPLY_FILTER_CRITERIA
)
export const feedUpdateModel = updateModel(FEED_UPDATE_MODEL)
export const feedUpdateImage = updateImage(FEED_UPDATE_IMAGE)
export const feedApplyModelUpdate = applyModelUpdate(FEED_APPLY_MODEL_UPDATE)
export const feedCancelModelUpdate = cancelModelUpdate(FEED_CANCEL_MODEL_UPDATE)

export const feedModerate = (moderation, rejection_reason) => ({
    type: FEED_MODERATE,
    moderation,
    rejection_reason
})

export const feedKnowledgeListInvalidationRequest = pagingRequest =>
    feedKnowledgeListPageRequest({
        ...pagingRequest,
        isInvalidating: true,
        offset: 0,
        nextOffset: 0
    })

export const feedToggleRejectionReasonModal = isRejectReasonModalOpen => ({
    type: FEED_TOGGLE_REJECTION_REASON_MODAL,
    isRejectReasonModalOpen: isRejectReasonModalOpen
})
